export const editSignupBackgroundColor = {
  success: true,
  isApp: false,
  // dark mode
  // backgroundColor: "#9927cf",
  // backgroundColorScheme: ["#9927cf", "#8621b5", "#731b9c"],
  // light mode
  backgroundColor: "#f3ff6a",
  backgroundColorScheme: ["#f3ff6a", "#dde860", "#cbd559"],
};
